<template>
<div>
  <page-header title="Members" >
    <template slot="secondary">
      <b-button variant="light" @click="$refs.members.refresh()">Refresh Data</b-button>
    </template>
  </page-header>
  <b-container>
    <p>{{count}} members</p>
    <b-table ref="members" hover :items="fetchData" :fields="fields" :current-page="currentPage" :per-page="perPage" primary-key="id">
      <template v-slot:cell(name)="data">
        <span v-router-link="{name:'MemberDetail',params:{id:data.item.id}}">{{data.item.name}}</span>
      </template>
    </b-table>
    <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="count"></b-pagination>
  </b-container>
</div>
</template>
<script>
import PageHeader from '@/components/global/PageHeader';
import {
  ListMembers,
  CountMembers
} from '@/gql/members/Members.gql'

export default {
  components: {
    PageHeader
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      fields: [
        'name',
        'score',
        {
          key: 'reached',
          label: 'Reached',
          formatter: value => {
            return value ? 'Yes' : 'No';
          }
        },
        {
          key: 'latestCall',
          label: 'Last Attempt',
          formatter: value => {
            return value ? this.$moment(value).fromNow() : 'Never';
          }
        },
        {
          key: 'completedAt',
          label: 'Completed',
          formatter: value => {
            return value ? 'Yes' : 'No'
          }
        },
        {
          key: 'timezone',
          label: 'Local Time',
          formatter: value => {
            return this.$moment.tz(value).format('HH:mm')
          }
        },
        {
          key: 'location',
          formatter: value => {
            return value ? `${value.city}, ${value.country_name}` : '';
          }
        },
        {
          key: 'createdAt',
          label: 'Joined',
          formatter: value => {
            return this.$moment(value).fromNow()
          }
        },
        {
          key: 'actionable',
          label: 'Next Step',
          formatter: value => {
            return value ? 'Call' : '-';
          }
        }
      ]
    }
  },
  methods: {
    async fetchData(ctx) {
      let data = await this.$apollo.query({
        query: ListMembers,
        variables: {
          limit: this.perPage,
          offset: ((this.currentPage - 1) * this.perPage)
        },
      })
      return data.data.members.map(m => {
        m.reached = m.recentCalls.filter(c => (c.status == 'completed')).length > 0;
        m.latestCall = m.recentCalls[0] ? m.recentCalls[0].createdAt : 0;
        const elapsed = Date.now() - (new Date(m.latestCall).getTime());
        const localHour = this.$moment.tz(new Date(), m.timezone).format('HH') * 1;
        m.actionable = (
          !m.reached // No successful calls
          && (elapsed > (1000*60*60*24)) // Last attempted more than 1 day ago
          && (8 < localHour) && (localHour < 19)
        )
        m._rowVariant = m.actionable ? 'success' : 'light';
        return m;
      });
    },
  },
  apollo: {
    count: {
      query: CountMembers,
      update(data) {
        return data.count.aggregate.count;
      }
    }
  }
}
</script>
<style scoped>
  .sortable tr {
    cursor: pointer;
  }
</style>
